import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
import { ConceptKind, ImplementationStatus, useCreateUserinputConceptLinkWithCustomSelectedConceptMutation, useGetUserInputLazyQuery, useGetUserQuery, useListConceptsLazyQuery, useUnlinkSelectedConceptMutation } from '~/types/types';
export default defineComponent({
  props: {
    questionnaireId: {
      type: Number,
      required: true
    },
    userInput: {
      type: Object,
      required: true
    },
    isEditable: {
      type: Boolean,
      default: false
    }
  },
  setup: function setup(props) {
    var _props$userInput$id;
    var createdParentConcept = ref(undefined);
    var resetCreatedParentConcept = function resetCreatedParentConcept() {
      createdParentConcept.value = undefined;
    };
    var listConceptInput = computed(function () {
      var _createdParentConcept, _createdParentConcept2;
      return {
        queryInput: {
          submeasureOfConceptsId: (_createdParentConcept = (_createdParentConcept2 = createdParentConcept.value) === null || _createdParentConcept2 === void 0 ? void 0 : _createdParentConcept2.id) !== null && _createdParentConcept !== void 0 ? _createdParentConcept : 0
        },
        limit: 1000,
        offset: 0
      };
    });
    var getLabel = function getLabel(label) {
      if (label.length > 20) {
        return label.substring(0, 20) + '...';
      }
      return label;
    };
    var _useListConceptsLazyQ = useListConceptsLazyQuery(listConceptInput),
      resultSubmeasures = _useListConceptsLazyQ.result,
      loadSubmeasures = _useListConceptsLazyQ.load,
      refetchSubmeasures = _useListConceptsLazyQ.refetch;
    var submeasures = computed(function () {
      var _resultSubmeasures$va, _resultSubmeasures$va2;
      return (_resultSubmeasures$va = (_resultSubmeasures$va2 = resultSubmeasures.value) === null || _resultSubmeasures$va2 === void 0 ? void 0 : _resultSubmeasures$va2.listConcepts) !== null && _resultSubmeasures$va !== void 0 ? _resultSubmeasures$va : [];
    });
    var _useGetUserInputLazyQ = useGetUserInputLazyQuery({
        id: (_props$userInput$id = props.userInput.id) !== null && _props$userInput$id !== void 0 ? _props$userInput$id : 0
      }),
      refetchUserInput = _useGetUserInputLazyQ.refetch,
      loadUserInput = _useGetUserInputLazyQ.load;
    var _useCreateUserinputCo = useCreateUserinputConceptLinkWithCustomSelectedConceptMutation(),
      createUserInputConceptLinkWithCustomSelectedConcept = _useCreateUserinputCo.mutate;
    var _useGetUserQuery = useGetUserQuery(),
      result = _useGetUserQuery.result;
    var email = computed(function () {
      var _result$value$getUser, _result$value, _result$value$getUser2;
      return (_result$value$getUser = result === null || result === void 0 ? void 0 : (_result$value = result.value) === null || _result$value === void 0 ? void 0 : (_result$value$getUser2 = _result$value.getUser) === null || _result$value$getUser2 === void 0 ? void 0 : _result$value$getUser2.email) !== null && _result$value$getUser !== void 0 ? _result$value$getUser : '';
    });
    var handleConceptInput = function handleConceptInput(value, isSubmeasure) {
      var _createdParentConcept3;
      createUserInputConceptLinkWithCustomSelectedConcept({
        userInputId: props.userInput.id,
        implementationStatus: ImplementationStatus.Doing,
        concept: {
          label: value.label,
          status: value.state || 'PROPOSED',
          kind: ConceptKind.Company,
          createdBy: email.value,
          isSubmeasure: isSubmeasure,
          sourceUrl: '',
          citation: ''
        },
        parentConceptId: isSubmeasure ? (_createdParentConcept3 = createdParentConcept.value) === null || _createdParentConcept3 === void 0 ? void 0 : _createdParentConcept3.id : undefined
      }).then(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(concept) {
          var _concept$data, _concept$data$createU;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                if (!isSubmeasure) {
                  _context.next = 10;
                  break;
                }
                ;
                _context.next = 4;
                return loadSubmeasures();
              case 4:
                _context.t0 = _context.sent;
                if (_context.t0) {
                  _context.next = 8;
                  break;
                }
                _context.next = 8;
                return refetchSubmeasures();
              case 8:
                _context.next = 11;
                break;
              case 10:
                createdParentConcept.value = concept === null || concept === void 0 ? void 0 : (_concept$data = concept.data) === null || _concept$data === void 0 ? void 0 : (_concept$data$createU = _concept$data.createUserinputConceptLinkWithCustomSelectedConcept) === null || _concept$data$createU === void 0 ? void 0 : _concept$data$createU.concept;
              case 11:
                ;
                _context.next = 14;
                return loadUserInput();
              case 14:
                _context.t1 = _context.sent;
                if (_context.t1) {
                  _context.next = 18;
                  break;
                }
                _context.next = 18;
                return refetchUserInput();
              case 18:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }()).catch(function (error) {
        console.error('handleConceptInput Mutation error:', error);
      });
    };
    var _useUnlinkSelectedCon = useUnlinkSelectedConceptMutation(),
      unlinkSelectedConcept = _useUnlinkSelectedCon.mutate;
    var removeSelectedConcept = function removeSelectedConcept(conceptId, isSubmeasure) {
      var _props$userInput$id2;
      if (!isSubmeasure) {
        createdParentConcept.value = undefined;
      }
      unlinkSelectedConcept({
        userInputId: (_props$userInput$id2 = props.userInput.id) !== null && _props$userInput$id2 !== void 0 ? _props$userInput$id2 : 0,
        conceptId: conceptId
      }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              loadUserInput() || refetchUserInput();
              if (!isSubmeasure) {
                _context2.next = 9;
                break;
              }
              ;
              _context2.next = 5;
              return loadSubmeasures();
            case 5:
              _context2.t0 = _context2.sent;
              if (_context2.t0) {
                _context2.next = 9;
                break;
              }
              _context2.next = 9;
              return refetchSubmeasures();
            case 9:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))).catch(function (error) {
        console.error('removeSelectedConcept Mutation error:', error);
      });
    };
    return {
      createdParentConcept: createdParentConcept,
      resetCreatedParentConcept: resetCreatedParentConcept,
      submeasures: submeasures,
      handleConceptInput: handleConceptInput,
      removeSelectedConcept: removeSelectedConcept,
      getLabel: getLabel
    };
  }
});